// Strips invisible Unicode codepoints that get pasted in from Gmail's
// rewrite/copy, AI chat output, or rich-text sources and would otherwise
// cause silent login failures or duplicate-account creation.
//
// Mirrors backend/utils/normalize.py:normalize_email so the same value
// the user sees in the input is what reaches the database.
//
// Codepoints stripped:
//   U+200B..U+200F  zero-width space, ZWNJ, ZWJ, LRM, RLM
//   U+2028..U+202F  line/paragraph separators, bidi controls
//   U+2060          word joiner
//   U+FEFF          BOM / zero-width no-break space
//   U+00AD          soft hyphen
const INVISIBLE_CHARS = new RegExp(
  "[\\u200B-\\u200F\\u2028-\\u202F\\u2060\\uFEFF\\u00AD]",
  "g"
);

// U+00A0 NO-BREAK SPACE — collapse to a regular space.
const NBSP = / /g;

export function normalizeEmail(value) {
  if (typeof value !== "string") return "";
  return value
    .normalize("NFKC")
    .replace(INVISIBLE_CHARS, "")
    .replace(NBSP, " ")
    .trim()
    .toLowerCase();
}

// Same cleanup, preserves case — useful for non-email login IDs where
// case may matter to the user (we still lowercase server-side, but the
// input field can display the original casing).
export function stripInvisible(value) {
  if (typeof value !== "string") return "";
  return value
    .normalize("NFKC")
    .replace(INVISIBLE_CHARS, "")
    .replace(NBSP, " ")
    .trim();
}
